import { SET_OFFERS, TOGGLE_OFFER } from './action-types';

export const setOffers = (dispatch, offers) => {
  dispatch({ type: SET_OFFERS, payload: offers });
};

export const toggleOffer = (dispatch, offer) => {
  dispatch({ type: TOGGLE_OFFER, payload: offer.toString() });
}